import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useProductDetailCTAContext } from './ProductDetailCTAContext';

const ErrorMessageWrapper = styled.div`
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`;

const ErrorMessage = styled.span`
  color: ${({ theme }) => theme.colors.errorMessage};
  font-size: 14px;
  font-weight: 600;
`;

function CTAErrorMessage({ isAssortmentTestProductDisabled }) {
  const { errorMessage, showErrors } = useProductDetailCTAContext();

  if (!errorMessage || !showErrors || isAssortmentTestProductDisabled) {
    return null;
  }

  return (
    <ErrorMessageWrapper>
      <ErrorMessage>{errorMessage}</ErrorMessage>
    </ErrorMessageWrapper>
  );
}

CTAErrorMessage.propTypes = {
  isAssortmentTestProductDisabled: PropTypes.bool,
};

export default CTAErrorMessage;
